import { computed, ref } from "vue";
import { brand } from "./brand";

export const THEME_STORAGE_KEY = "cdp-theme";
export type ThemePreference = "system" | "light" | "dark";

export const themePreference = ref<ThemePreference>("system");
export const isDarkTheme = ref(false);
export const themeToggleLabel = computed(() => isDarkTheme.value ? "Включить светлую тему" : "Включить тёмную тему");

let media: MediaQueryList | null = null;
let initialized = false;

function storedPreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return stored === "light" || stored === "dark" ? stored : "system";
  } catch {
    return "system";
  }
}

function applyTheme(dark: boolean): void {
  isDarkTheme.value = dark;
  document.documentElement.classList.toggle("dark", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";
}

function onSystemTheme(event: MediaQueryListEvent): void {
  if (themePreference.value === "system") applyTheme(event.matches);
}

export function initializeTheme(): void {
  if (brand.id !== "vkusnodomoy") return;
  if (initialized) return;
  initialized = true;
  media = window.matchMedia("(prefers-color-scheme: dark)");
  themePreference.value = storedPreference();
  applyTheme(themePreference.value === "system" ? media.matches : themePreference.value === "dark");
  media.addEventListener("change", onSystemTheme);
}

export function toggleTheme(): void {
  if (brand.id !== "vkusnodomoy") return;
  const next: Exclude<ThemePreference, "system"> = isDarkTheme.value ? "light" : "dark";
  themePreference.value = next;
  try { localStorage.setItem(THEME_STORAGE_KEY, next); } catch { /* тема всё равно меняется для текущей вкладки */ }
  applyTheme(next === "dark");
}
